export default "__VITE_ASSET__DhFAPwl2__"